import React from 'react';
import {TransitionGroup, CSSTransition} from 'react-transition-group';
import { DFPSlotsProvider } from 'react-dfp';

import Ad from './Ad';
import BaseHead from './BaseHead';
import BaseHeader from './BaseHeader';
import Draft from './Draft';
import FinishedTeam from './FinishedTeam';
import FinalizeTeam from './FinalizeTeam';
import Footer from './Footer';
import FreeAgents from './FreeAgents';
import HeroDisplay from './HeroDisplay';
import ModalWindow from './ModalWindow';
import MyTeam from './MyTeam';
import RecircLinks from './RecircLinks';
import TeamSignings from './TeamSignings';

import baseData from '../data';
import loadFont from '../js/utils/loadFont';

import '../css/base.css';

class App extends React.Component {
  state = baseData;

  resetData = (viaClick) => {
    const data = {...this.state};
    const players = Object.keys(data.players);

    players.forEach(player => data.players[player].signed = '');
    data.baseSalary = 55;
    data.cap = 55;
    data.remaining = 55;
    data.signings = [];
    data.signingsPositions = 0;

    if (viaClick) {
      data.reset = true;
    }

    this.setState(data);
  }

  // loading saved progress from local storage
  componentDidMount() {
    // const localStorageRef = localStorage.getItem('bg-patriots-rebuild');
    // if (localStorageRef) {
    //   this.setState(JSON.parse(localStorageRef));
    // }


    // provides a method to reset the data to the original state
    // if the url contains a queryString param of dataState=reset
    const queryString = window.location.search;

    const urlParams = new URLSearchParams(queryString);
    const dataState = urlParams.get('dataState');

    if (dataState === 'reset') {
      this.resetData();
    }


    loadFont([
      { family: 'Benton', suffix: 'bold' },
      { family: 'Benton', suffix: 'regular' },
      { family: 'Miller', suffix: 'regular' },
      { family: 'Miller', suffix: 'bold' },
      { family: 'Benton-Cond', suffix: 'regular' },
      { family: 'Benton-Cond', suffix: 'bold' },
    ]);
  }

  // saving changes into local storage
  componentDidUpdate() {
    // localStorage.setItem('bg-patriots-rebuild', JSON.stringify(this.state))

    // if (this.state.overCap.over) {
    //   document.querySelector('body').classList.add('lock');
    // } else {
    //   setTimeout(() => {
    //     document.querySelector('body').classList.remove('lock');
    //   }, 510)
    // }
  }

  freeAgentsRef = React.createRef();
  finishedTeamRef = React.createRef();

  userIsFinished = () => {
    const data = {...this.state};
    data.isFinished = true;

    data.finishedView["viewed"] = {
      value: false,
    };

    this.setState(data);
  }

  clearTeam = () => {
    const data = {...this.state};
    // clear selections
    data.selections = {};
    // reset isFinished
    data.isFinished = false;
    // mark all players as unselected
    Object.keys(data.players).map(key => data.players[key].selected = false);
    // reset financials
    data.spent = 0;
    data.remaining = data.cap;
    // clear drafted
    data.drafted = '';
    // set state
    this.setState(data);
    // scroll page back to free agents
    this.freeAgentsRef.current.scrollIntoView();
  }

  alterTeam = (fa, salary, playerKey, action) => {
    const data = {...this.state};

    // if our action is to add player
    if (action === 'Add player') {

      if (salary > data.remaining) {

        // set over the cap object;
        data.overCap['over'] = {
          isOver: true,
          overBy: salary - data.remaining,
          player: fa,
        };
      } else {
        // add player object passed to selections state
        data.selections[`selection_${playerKey}`] = fa;

        // adjust salary spent and remaining
        data.remaining -= salary;
        data.spent += salary;

        // alter selected state of player object
        data.players[playerKey].selected = true;

        // added in the drafted value
        if (fa.type === 'draft') {
          data.drafted = fa.name;
        }
        
      }
    } else if (action === 'Remove player') {
      // else if we are removing player

      // clear the drafted value
      if (fa.type === 'draft') {
        data.drafted = '';
      }

      // delete the player object from selections state
      delete data.selections[`selection_${playerKey}`];

      // update salary spent and remaining
      data.remaining += salary;
      data.spent -= salary;

      // alter selected state of player object
      data.players[playerKey].selected = false;
    }

    //set state
    this.setState(data);
  }

  removePlayer = (plKey, salary) => {
    // find the original player key by parsing the selection key
    const playerKey = plKey.split('_')[1];

    // make a copy of state
    const data = {...this.state};

    if (data.selections[plKey].type === 'draft') {
      data.drafted = '';
    }

    // delete the player from the selections state
    delete data.selections[plKey];

    // update salary spent and remaining
    data.remaining += salary;
    data.spent -= salary;

    // update player object's selected state
    data.players[playerKey].selected = false;

    // set state
    this.setState(data);
  }

  filterPositions = (filter, key) => {
    let data = {...this.state}
    data[key] = filter;
    this.setState(data);
  }

  acknowledgeCapWarning = () => {
    let data = {...this.state}
    data.overCap = {};
    this.setState(data);
  }

  closeFinishedModal = () => {
    let data = {...this.state}
    data.finishedView = {};
    this.setState(data);
  }

  closeResetModal = () => {
    let data = {...this.state}
    data.reset = false;
    this.setState(data);
  }

  viewTeam = () => {
    this.closeFinishedModal();
    setTimeout(() => {
      this.finishedTeamRef.current.scrollIntoView();
    }, 510)
  }


  render() {

    // determines if any selections have been made, and if so, sets a class for the article element
    const selections = Object.keys(this.state.selections).length > 0 ? 'with-picks' : 'empty';

    const adSection = baseData.meta.sectionUrl.replace(/http[s]*?:\/\/(www\.)?/, '');
    const [s1, s2, s3, s4] = adSection.split('/');

    const adTargetingArguments = {
      section: adSection,
      s1,
      s2,
      s3,
      s4,
      pageurl: baseData.meta.url.replace('https://apps.bostonglobe.com', '').replace(/\//g, '_'),
      pgtype: 'article',
      meta: baseData.meta.keywords.split(',').map((keyword) => keyword.trim()),
    };

    return (
      <DFPSlotsProvider dfpNetworkId={"61381659"} targetingArguments={adTargetingArguments}>
        <div id="ap-content">
          
          <BaseHeader
            sectionURL={this.state.meta.sectionUrl}
            section={this.state.meta.section}
            social={this.state.meta.social}
            url={this.state.meta.url}
            title={this.state.meta.title}
          />
          
          <article id="rebuilding__content" className={`${selections}`}>
            {/* <BaseMeta metatags={this.state.meta} /> */}
          
            <BaseHead />
          
            <div className="content-well">
              <MyTeam
                cap={this.state.cap}
                selectionGroup={this.state.selections}
                spent={this.state.spent}
                remaining={this.state.remaining}
                removePlayer={this.removePlayer}
                teamView={this.state.teamView}
                submitTeam={this.userIsFinished}
              />
              <HeroDisplay 
                pubDate={this.state.meta.publishDate}
                updateDate={this.state.meta.updateDate}
              />
            
            </div>
            
            <div className="content-well">

              <p className="benton-regular body-copy">It’s time to play Patriots general manager. Why let Bill Belichick have all the fun?</p>
              <p className="benton-regular body-copy">We created a database of the top 150 free agents across the NFL and assigned each player a salary cap number, allowing you the chance to rebuild the 2021 Patriots. Players will come off the board as teams sign them throughout free agency.</p>
              <p className="benton-regular body-copy"><a href="https://www.bostonglobe.com/2021/03/15/sports/patriots-free-agency-offseason-news/" rel="noreferrer" target="_blank">See the latest free-agency news and rumors</a>, and get caught up on where things stand before you build your team.</p>



              {this.state.signings.length === 0 ? (
                <div>
                  <p className="benton-regular body-copy">The parameters: While the Patriots have $76 million in cap space, it’s really more like $69 million once the Trent Brown trade becomes official on March 17 (and that's counting the $7 million cleared by trading Marcus Cannon to the Texans). And like a real GM, you can’t spend the Patriots’ cap space down to $0. You have to leave about $15 million in space to sign rookies and other players during the season. We’ve set your cap at ${this.state.cap} million.</p>
                  <p className="benton-regular body-copy">The Patriots <a href="https://www.bostonglobe.com/2021/03/12/sports/patriots-re-sign-quarterback-cam-newton-one-year-deal/" rel="noreferrer" target="_blank">re-signed quarterback Cam Newton</a>, but that doesn’t mean he’ll be their Week 1 starter, so we’ve left him on the board. Build your team around him, or pick a different QB. Just make sure you don’t overspend, because the Patriots have big need at four other positions: receiver, defensive tackle, linebacker, and cornerback. Take those into account as you try to rebuild the roster, and we’ll let you know how you did when you submit your team.</p>
                  <p className="benton-regular body-copy">If you want to <a href="https://apps.bostonglobe.com/sports/graphics/2021/03/rebuilding-the-new-england-patriots">see the board as it stands now</a>, with signed players unavailable and a cap number that reflects the Patriots’ signings, click here.</p>
                </div>
              ) : (
                <div>
                  <p className="benton-regular body-copy">The parameters: While the Patriots started with $76 million, it is really more like $69 million once the Trent Brown trade becomes official on March 17 (and that’s counting the $7 million cleared by trading Marcus Cannon to the Texans. Like a real GM, you can’t spend the cap space down to $0. You have to leave about $15 million in space to sign rookies and other players during the season. The Patriots have already bolstered the roster with a number of free-agent signings but haven’t committed a ton of cap space to them, so your number is set at ${this.state.cap} million.</p>
                  <TeamSignings 
                    signings={this.state.signings}
                  />
                  <p className="benton-regular body-copy">We’ve outlined five key areas of need: quarterback, receiver, defensive tackle, linebacker, and cornerback. Take those into account as you try to rebuild the roster, and we’ll let you know know how you did when you submit your team. Our free-agent board is updated to reflect the latest signings, but you <button onClick={this.resetData} className='inline-button button--red'>can start with a clean slate</button> and at the beginning of free agency if you'd like.</p>
                </div>
              )
              }
              <p className="benton-regular body-copy">Once you’ve made your selections, you can add one more player via the draft. Choose among the pool of players likely to be available at No. 15.</p>
              <p className="benton-regular body-copy">So, what’s the best team you can put together?</p>
              <div ref={this.freeAgentsRef} className="rebuild__section">
                <FreeAgents
                  freeAgentGroup={this.state.players}
                  alterTeam={this.alterTeam}
                  drafted={this.state.drafted}
                  filterPositions={this.filterPositions}
                  positionFilterHigh={this.state.positionFilterHigh}
                  positionFilterMedium={this.state.positionFilterMedium}
                  positionFilterLow={this.state.positionFilterLow}
                />
              </div>

            </div>

            <Ad adslot="ad_inarticle1" section={adSection} />
            <div className="content-well">
              
              <div className="rebuild__section">
                <Draft 
                  draftGroup={this.state.players} 
                  alterTeam={this.alterTeam}
                  drafted={this.state.drafted}
                  filterPositions={this.filterPositions}
                  positionFilterDraft={this.state.positionFilterDraft}
                  />
              </div>

              <FinalizeTeam 
                selections={this.state.selections}
                isFinished={this.state.isFinished}
                userIsFinished={this.userIsFinished}
              />

              <div id="finished-team" ref={this.finishedTeamRef} className={"rebuild__section" + (this.state.isFinished ? "" : " no-show")}>
                <FinishedTeam
                  selections={this.state.selections}
                  isFinished={this.state.isFinished}
                  url={this.state.meta.url}
                  clearTeam={this.clearTeam}
                  positionsOfNeed={this.state.positionsOfNeed}
                  signings={this.state.signings}
                />
              </div>
              
            </div>
            <Ad adslot="ad_inarticle2" section={adSection} />
            <div className="content-well">
              <p className='body-copy photo-credit benton-regular'>Ages as of March 17, 2021.<br /> NFL player photos by The Associated Press. Draft player photos courtesy of Alabama, U-M Athletics, Virginia Tech, Northwestern, University of Miami, Georgia, Notre Dame, and Tulsa.</p>


              <RecircLinks 
                recirc={this.state.recirc}
              />
            </div>

            <TransitionGroup component="div" className="modal-window">
              {Object.keys(this.state.overCap).map(key =>
                <CSSTransition classNames="modal-window" key={key} timeout={{enter: 500, exit: 500}}>
                  <ModalWindow
                    hed='You’re over the cap!'
                    deck={<p className='benton-regular'>Signing <span className='cap__highlight'>{this.state.overCap[key].player.name}</span> will put you over the projected salary cap by <span className='cap__highlight'>${this.state.overCap[key].overBy} million</span>. Either remove someone from your team or sign someone else for less money.</p>}
                    button1Function={this.acknowledgeCapWarning} 
                    button1Text='Got it'
                    button2Function={this.viewTeam}
                    button2Text=''
                  />
                </CSSTransition>
              )}
            </TransitionGroup>

            <TransitionGroup component="div" className="modal-window">
              {Object.keys(this.state.finishedView).map((key) => {
                  if (this.state.finishedView[key].value === false) {
                    return (
                      <CSSTransition classNames="modal-window" key={key} timeout={{enter: 500, exit: 500}}>
                        <ModalWindow
                          hed='You’re all done!'
                          deck={<p className='benton-regular'>With your additions, the Patriots are set up to start rebuilding their dynasty. See your roster additions below, or click the button below to make changes.</p>}
                          button1Function={this.closeFinishedModal}
                          button1Text='Adjust my team'
                          button2Function={this.viewTeam}
                          button2Text='View Team' 
                        />
                      </CSSTransition>
                    )
                  } return null;
                }
              )}
            </TransitionGroup>

            <TransitionGroup component="div" className="modal-window">
              {Object.keys(this.state).map((key) => {
                  if (this.state.reset === true) {
                    return (
                      <CSSTransition classNames="modal-window" key={key} timeout={{enter: 500, exit: 500}}>
                        <ModalWindow
                          hed='Turning back the clock'
                          deck={<p className='benton-regular'>We’ve updated our group of players to the original offseason list of free agents where every player is available to sign. </p>}
                          button1Function={this.closeResetModal}
                          button1Text='Got it'
                          button2Function={this.viewTeam}
                          button2Text='' 
                        />
                      </CSSTransition>
                    )
                  } return null;
                }
              )}
            </TransitionGroup>
          </article>
          <Footer 
            credits={this.state.credits}
          />
          {/* <BaseFooter /> */}
        </div>
      </DFPSlotsProvider>
    )
  }
}

export default App;
